import React, { FC } from 'react';
import { ChevronDown } from 'lucide-react';

import { Guest } from 'types/guest.types';
import { Button } from 'epoch-ui/components/Button';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent
} from 'epoch-ui/components/DropdownMenu';
import { SearchInput } from '@epoch-ui/components/SearchInput';
import LoadingSpinner from 'components/common/loaders/LoadingSpinner';

export interface SelectGuestDropdownProps {
  guests: Guest[];
  selectedGuest?: Guest;
  onSearch: (searchText: string) => void;
  onSelect: (guest: Guest) => void;
  loading: boolean;
}

export const SelectGuestDropdown: FC<SelectGuestDropdownProps> = ({
  guests,
  selectedGuest,
  onSearch,
  onSelect,
  loading
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="tw-w-full tw-justify-between tw-rounded-[8px] tw-border-[1.5px] tw-border-solid tw-border-border-grey tw-bg-white tw-font-normal tw-text-black">
          {selectedGuest ? (
            <div>
              {selectedGuest.firstName} {selectedGuest.lastName}{' '}
              <span className="tw-text-primary-grey">({selectedGuest.email})</span>
            </div>
          ) : (
            <span>Select a guest</span>
          )}
          <ChevronDown size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="tw-w-full tw-min-w-[var(--radix-dropdown-menu-trigger-width)]">
        <SearchInput
          className="tw-w-full"
          onChange={({ target: { value: searchText } }) => onSearch(searchText)}
        />
        <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
          {loading ? (
            <LoadingSpinner />
          ) : (
            guests.map((guest, index) => (
              <DropdownMenuItem key={index} onClick={(): void => onSelect(guest)}>
                <div>
                  {guest.firstName} {guest.lastName}{' '}
                  <span className="tw-text-primary-grey">({guest.email})</span>
                </div>
              </DropdownMenuItem>
            ))
          )}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
